module.exports = __webpack_public_path__ + "static/media/lisaEvans.50c4a993.jpg";